import { DbFolder, DbTender, DbTenderFolder } from '~src/types/db';

/**
 * Returns all father lineage for child with id
 * @param arr - folderQuery.data list
 * @param id - leaf id
 */
export const getParentsIds = (
  arr: (DbFolder | DbTenderFolder)[],
  id: string
): string[] => {
  const ids: string[] = [];

  // Asserting each element to DbFolder since we're only accessing common properties
  const dbFolder = arr.find((v) => String((v as DbFolder).id) === id);
  if (!dbFolder) return ids;

  let parent = arr.find(
    (v) => (v as DbFolder).id === (dbFolder as DbFolder).parent_id
  );
  while (parent && (parent as DbFolder).id) {
    ids.unshift(String((parent as DbFolder).id));

    const nextId = (parent as DbFolder).parent_id;
    parent = arr.find((v) => (v as DbFolder).id === nextId);
  }

  return ids;
};

interface InsertAtParentIdParams {
  /** folderQuery.data */
  arr: DbFolder[];
  /** folder to insert */
  folder: DbFolder;
}
/**
 * Insert folder next to its siblings
 */
export const insertAtParentId = ({
  arr,
  folder,
}: InsertAtParentIdParams): DbFolder[] => {
  // for parentId=null, insert at beginning
  if (folder.parent_id === null) return [folder, ...arr];

  const index = arr.findIndex((v) => v.parent_id === folder.parent_id);
  // if new child insert at end
  if (index < 0) return [...arr, folder];

  const nextArr = [...arr];
  // insert at index
  nextArr.splice(index, 0, folder);
  return nextArr;
};

/** Gather all subfolders in the tree in a flat list */
export const getFolderChildren = (
  /** folder list */
  arr: DbFolder[],
  /** root folder */
  parent: DbFolder
): DbFolder[] => {
  const children = arr.filter((v) => v.parent_id === parent.id);

  children.forEach((child) => {
    children.push(...getFolderChildren(arr, child));
  });

  return children;
};
